import invoiceService from '../../../services/invoiceService';

// Get franchisee ID for current context
export const getFranchiseeId = (userProfile) => {
  if (userProfile?.role === 'admin') {
    return 'all';
  } else if (userProfile?.role === 'franchisee') {
    return userProfile.id;
  } else if (userProfile?.role === 'technician' && (userProfile?.franchiseeId || userProfile?.assignedFranchiseeId)) {
    return userProfile.franchiseeId || userProfile.assignedFranchiseeId;
  }
  return null;
};

// Utility functions
export const formatCurrency = invoiceService.formatCurrency;
export const formatDate = invoiceService.formatDate;